<template>
  <div class="details_content_repeat">
    <QS-h4-title title="相关应付信息" />
    <QS-common-table
        :columns="paymentInfoHeader"
        :data="paymentInfoList"
        :loading="loading"
        :pagination="paginationData"
        @change="paginationChange"
    ></QS-common-table>
  </div>
</template>

<script setup>
import { ref, watch, getCurrentInstance } from 'vue'
import { getOrderPaymentList } from '@/api/domain/orders'
import config from '../config/detail'

const props = defineProps({
  payInfo: {
    type: Object,
  },
})
const { proxy } = getCurrentInstance()
const { paymentInfoHeader } = config.call(proxy)
const paymentInfoList = ref([])
const paginationData = ref({
  pageSize: 10,
  pageNum: 1,
  total: 0,
  pageSizes: [10, 20, 30, 50],
})
const loading = ref(false)

const getPaymentList = async () => {
  loading.value = true
  const { code, data } = await getOrderPaymentList({
    id: props.payInfo.id,
    pageNum: paginationData.value.pageNum,
    pageSize: paginationData.value.pageSize,
  })
  loading.value = false
  if (code === 1) {
    paymentInfoList.value = data.items
    paginationData.value.total = data.totalNum
    paginationData.value.pageNum = data.pageNum
  }
}

const paginationChange = ({ pagination }) => {
  const { pageNum, pageSize } = pagination
  paginationData.value.pageNum = pageNum
  paginationData.value.pageSize = pageSize
  getPaymentList()
}

watch(() => props.payInfo.id, (val) => {
  if (val) {
    getPaymentList()
  }
}, { immediate: true })
</script>
